import { render, staticRenderFns } from "./ButtonsGroupPage.vue?vue&type=template&id=476f69b5&scoped=true&"
import script from "./ButtonsGroupPage.vue?vue&type=script&lang=js&"
export * from "./ButtonsGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsGroupPage.vue?vue&type=style&index=0&id=476f69b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f69b5",
  null
  
)

export default component.exports